import { URL } from '@/util/url'
import compact from 'lodash/compact'

type MaybePath = string | Array<string | null>

/**
 * SPA内部でリダイレクトするためのSPAフルパスを構築.
 *
 * ルーティングフック用に使われる想定で、関数のパラメータ型も
 * query などで指定されたパスを構築するケースを念頭においている
 */
export function buildAbsoluteSpaPathForRedirect(paths: MaybePath): string {
  const flattenPaths = paths instanceof Array ? compact(paths) : [paths]
  const path = URL.join(...flattenPaths)

  return URL.isAbsoluteSpaPath(path)
    ? path
    : URL.join('/s', path)
}
